module.exports = __webpack_public_path__ + "b019102bd435474644ceac15760654e4.png";